<template>
	<el-dialog :visible.sync="showwin" :title="selectsort_lang.selectsortdialogtitle" :width="width" :append-to-body="true" 
	 :close-on-click-modal="false" :destroy-on-close="true">
		<sortlist ref="sortlist" style="margin-top:-20px" :isdialog="isdialog" :urlparam="param" @checkedsortfun="checkedsortfun"></sortlist>
	</el-dialog>
</template>
<script>
import Utils from '../../lib/util.js';
import sortlist from '../../components/baseinfo/sortlist.vue'
export default {
	components: {
		sortlist
	},
	props: {},
	data() {
		return {
			showwin:false,
			width:(window.innerWidth*60/100)+'px',
			selectsort_lang:{},
			param:'',
			isdialog:true
		}
	},
	mounted() {
		
	},
	methods:{
		init(param){
			debugger
			if(param!=undefined)
				this.param=param;
				
			if(this.$refs.sortlist!=undefined){
				this.$refs.sortlist.init(param);
			}	
			this.loadlanguage();
		},
		loadlanguage(){
			var that=this;
			this.$public.GetLanguageByMode('selectsort',this).then(res=>{
				if(res.state=='1')
				{
					that.selectsort_lang=that.$lang.label.selectsort;
					that.showwin=true;
				}	
			});
		},
		checkedsortfun(e){
			this.$emit('checkedsortcallback',e);
		}
	}
}
</script>

<style>
</style>